import { render, staticRenderFns } from "./user_course_detail.vue?vue&type=template&id=df2e955e&scoped=true&"
import script from "./user_course_detail.vue?vue&type=script&lang=js&"
export * from "./user_course_detail.vue?vue&type=script&lang=js&"
import style0 from "./user_course_detail.css?vue&type=style&index=0&id=df2e955e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2e955e",
  null
  
)

export default component.exports